import { Retrospectives } from '@buildwise/libs/admin';

function CompanyRetrospectives() {
  return (
    <>
      <Retrospectives isCompanyConfig />
    </>
  );
}

export default CompanyRetrospectives;
